import FetchableMetricSection from 'components/FetchableMetricSection'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import {
  RetentionRateCumulativeMetric,
  ShortType,
} from 'models/RetentionRateMetric'
import React from 'react'
import { useSelector } from 'react-redux'
import { push } from 'react-router-redux'
import { daysUntilReportAccess, getBenchmarkRate } from 'scenes/Reports/helpers'
import { AVAILABLE_IN_DAYS } from 'scenes/Reports/RetentionRateReport/helpers'
import { selectRetentionRateMetricByType } from 'selectors/retentionRateMetric'
import AvailableAfterButton from '../AvailableAfterButton'
import Benchmark from '../Benchmark'
import Card from '../Card'
import MetricCounter from '../MetricCounter'
import { MetricCardT } from './index'

const t = buildTranslate('home.metrics')

const RetentionRateMetric: React.FC<MetricCardT> = ({ merchant }) => {
  const dispatch = useDispatch()

  const cumulativeMetrics = useSelector(state =>
    selectRetentionRateMetricByType(state, merchant?.id, ShortType.CUMULATIVE)
  ) as RetentionRateCumulativeMetric

  const { rate: benchmarkRate } = getBenchmarkRate(
    merchant.merchant_type,
    'retention_rate'
  )

  const remainingDays = daysUntilReportAccess(merchant, AVAILABLE_IN_DAYS)
  const shouldFetch = Boolean(remainingDays !== null && remainingDays < 1)

  return (
    <Card
      title={t('retention_rate.title')}
      onClick={() => dispatch(push('/reports/retention_rate'))}
      sections={[
        { content: t('retention_rate.popovers.section_1') },
        {
          title: t('shared.popovers.example'),
          content: t('retention_rate.popovers.section_2'),
        },
      ]}
    >
      <FetchableMetricSection
        merchantId={merchant?.id}
        shouldFetch={shouldFetch}
        type="retention_rate_metric"
        metricTypes={[ShortType.CUMULATIVE]}
      >
        {shouldFetch || cumulativeMetrics?.isLoading ? (
          <MetricCounter
            currentRate={cumulativeMetrics?.current?.retention_rate}
            previousRate={cumulativeMetrics?.previous?.retention_rate}
            isLoading={cumulativeMetrics?.isLoading}
            isErrored={cumulativeMetrics?.isErrored}
          />
        ) : (
          <AvailableAfterButton
            willBeAvailableAfterLaunch={remainingDays === null}
            remainingDays={remainingDays}
          />
        )}
        <Benchmark benchmarkRate={benchmarkRate} />
      </FetchableMetricSection>
    </Card>
  )
}

export default RetentionRateMetric
